/* eslint-disable max-len */
import React, {useState} from 'react'
import Input from '../../../../../components/InputBox'
import CustomeDatePicker from '../../../../../components/DatePicker'
import DropDownComponent from './DropDownComponent'
import UploadFileInput from '../../../../../components/UploadFileInput'
import ProfileImageUpload from '../../../../../components/ProfileImageUpload'
import FileUploadIcon from '../../../../../components/FileUploadIcon'
import moment from 'moment'
import ImageSizeTooltip from '../../../../../components/ProfileImageUpload/imageSizeTooltip'

const BasicDetails = ({ 
    edit,
    studentDetails,
    setStudentDetails,
    handleInput,
    handleDropdown,
    submitSelected,
    setsubmitSelected,
    handleDropDownValue,
    handleUploadAadhaar,
    handleSelectedDate,
    imageSizeInfoHover,
    setImageSizeInfoHover,
    setformatError,
    setimageLoading,
    setToastErrorMessage,
    parentDetails,
    setParentDetails,
    handleParentInput,
    customError,
    showDropdown}) => {

    const [dateError, setdateError] = useState("");

    const bloodGroupTypes = ['A+', "A-", "B+", "B-", "AB+", "AB-","O+", "O-"]

    const genderTypes=['Male', 'Female', 'Others']

    const statusTypes=['APL', 'BPL', 'Others']

    const religionTypes=['Hindu', 'Muslim', 'Christian', 'Sikh', 'Buddhist', 'Jain', 'Parsi', 'Others']

    const casteCategoryTypes=['OC', 'BC', 'OBC', 'SC', 'ST']

    /**
     * The function disables future dates by comparing the current date with the end of the current
     * day.
     * @returns a boolean value. It checks if the "current" date is after the current date and returns
     * true if it is, indicating that the date is disabled. Otherwise, it returns false, indicating
     * that the date is not disabled.
     */
    const disabledFutureDate = (current) => {
        // Disable dates that are after the current date
        return current && current > moment().endOf('day');
    };
    
    const handleImageToggle = () => {
        // Use the functional form of setState
        setImageSizeInfoHover((prevIsToggled) => !prevIsToggled);
    };

    return (
        <div class="border border-[#D0D5DD] p-3 rounded basic_details_section mb-8">
            <div class="flex">
                <div class="pr-4 w-1/2">
                    <div className='flex'>
                        <ProfileImageUpload
                            edit={edit}
                            mainKey="student"
                            imageid={"image_url"}
                            studentDetails={studentDetails}
                            setStudentDetails={setStudentDetails}
                            imageSizeInfoHover={imageSizeInfoHover}
                            setImageSizeInfoHover={setImageSizeInfoHover}
                            setformatError={setformatError}
                            setimageLoading={setimageLoading}
                            setToastErrorMessage={setToastErrorMessage}
                        />
                        {edit &&
                        <div className='mt-5'>
                            <p>Student ID</p>
                            <p className='font-semibold'>{studentDetails.student_id}</p>
                        </div>
                        }
                    </div>
                    <div class="flex items-center w-full pt-[0.5rem] mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[118px] inline-flex">First Name<span class="req-fld-astrk">*</span></label>
                        <Input
                            type="text"
                            state={studentDetails}
                            id='first_name'
                            maxLength={30}
                            isMandatoryField={true}
                            placeholder="Enter First Name"
                            handleInput={handleInput}
                            submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                        />
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[118px] inline-flex">Middle Name</label>
                        <Input
                            type="text"
                            state={studentDetails}
                            id='middle_name'
                            maxLength={30}
                            placeholder="Enter Middle Name"
                            handleInput={handleInput}
                            //submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                        />
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[118px] inline-flex">Last Name</label>
                        <Input
                            type="text"
                            state={studentDetails}
                            id='last_name'
                            maxLength={30}                            
                            placeholder="Enter Last Name"
                            handleInput={handleInput}
                            //submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                        />
                    </div>
                    <div class="relative flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[118px] inline-flex">Date of Birth<span class="req-fld-astrk">*</span></label>
                        <div class="relative w-[50%] 2xl:w-[45%]">
                            <CustomeDatePicker 
                                setToastErrorMessage={setToastErrorMessage}
                                setsubmitSelected={setsubmitSelected}
                                id='date_of_birth'
                                showErrorBorder={submitSelected && studentDetails.date_of_birth === ""}
                                isMandatoryField={true}
                                format="MMM DD, YYYY"
                                state={studentDetails}
                                disabledFutureDate={disabledFutureDate}
                                placeholder="Select Date"
                                imageClass={true}
                                setdateError={setdateError}
                                handleSelect={handleSelectedDate}
                                //onBlur={onBlur}
                            />
                        </div>
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[118px] inline-flex">Blood Group<span class="req-fld-astrk">*</span></label>
                        <DropDownComponent
                            divClassName={'relative w-[50%] 2xl:w-[45%]'} 
                            showErrorBorder={submitSelected && studentDetails.blood_group === ""}
                            options={bloodGroupTypes}
                            dropdownkey={"blood_group"}
                            studentDetails={studentDetails}
                            submitSelected={submitSelected}
                            handleDropDownValue={handleDropDownValue}
                            showDropdown={showDropdown}
                            handleDropdown={handleDropdown}
                            placeholder={"Blood Group"}
                            selectedvalue={studentDetails.blood_group}
                            displayAbove={true}
                        />
                    </div>
                    <div class="flex items-center w-full">
                        <label class="text-f7 font-normal text-[#031624] min-w-[118px] inline-flex">Gender<span class="req-fld-astrk">*</span></label>
                        <DropDownComponent
                            divClassName={'relative w-[50%] 2xl:w-[45%]'} 
                            showErrorBorder={submitSelected && studentDetails.gender === ""}
                            options={genderTypes}
                            dropdownkey={"gender"}
                            studentDetails={studentDetails}
                            submitSelected={submitSelected}
                            handleDropDownValue={handleDropDownValue}
                            showDropdown={showDropdown}
                            handleDropdown={handleDropdown}
                            placeholder={"Gender"}
                            selectedvalue={studentDetails.gender}
                            displayAbove={true}
                        />
                    </div>
                </div>
                <div class="w-1/2 pl-4 mt-3 border-l border-[#D0D5DD]">
                    <div class="relative flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[155px] inline-flex">Date of Admission<span class="req-fld-astrk">*</span></label>
                        <div class="relative w-[42%] 2xl:w-[50%]">
                            <CustomeDatePicker 
                                setToastErrorMessage={setToastErrorMessage}
                                setsubmitSelected={setsubmitSelected}
                                id='date_of_admission'
                                showErrorBorder={submitSelected && studentDetails.date_of_admission === ""}
                                format="MMM DD, YYYY"
                                state={studentDetails}
                                placeholder="Select Date"                                
                                imageClass={true}
                                setdateError={setdateError}
                                handleSelect={handleSelectedDate}
                                //onBlur={onBlur}
                                disabled={
                                    studentDetails.disable_doa
                                }
                            />
                        </div>
                        <div class="relative self-end ml-2" style={{ 'top': '-7px' }}>
                            <ImageSizeTooltip
                                handleImageToggle={handleImageToggle}
                                imageSizeInfoHover={imageSizeInfoHover}
                                imgtransform={'scale(1.2)'}
                                tooltipFor={'Student_DOA'}
                            />
                        </div>
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[155px] inline-flex">Nationality<span class="req-fld-astrk">*</span></label>
                        <Input
                            type="text"
                            state={studentDetails}
                            id='nationality'
                            maxLength={30}
                            inputWidth={`w-[42%] 2xl:w-[50%]`}
                            isMandatoryField={true}
                            placeholder="Enter Nationality"
                            handleInput={handleInput}
                            submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                        />
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[155px] inline-flex" >Economic Status<span class="req-fld-astrk">*</span></label>
                        <DropDownComponent
                            divClassName={'relative w-[42%] 2xl:w-[50%]'}  
                            showErrorBorder={submitSelected && studentDetails.economic_status === ""}
                            isMandatoryField={true}
                            options={statusTypes}
                            dropdownkey={"economic_status"}
                            studentDetails={studentDetails}
                            submitSelected={submitSelected}
                            handleDropDownValue={handleDropDownValue}
                            showDropdown={showDropdown}
                            handleDropdown={handleDropdown}
                            placeholder={"Select Status"}
                            selectedvalue={studentDetails.economic_status}
                        />
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[155px] inline-flex">Religion<span class="req-fld-astrk">*</span></label>
                        <DropDownComponent
                            divClassName={'relative w-[42%] 2xl:w-[50%]'}  
                            showErrorBorder={submitSelected && studentDetails.religion === ""}
                            isMandatoryField={true}
                            options={religionTypes}
                            dropdownkey={"religion"}
                            studentDetails={studentDetails}
                            submitSelected={submitSelected}
                            handleDropDownValue={handleDropDownValue}
                            showDropdown={showDropdown}
                            handleDropdown={handleDropdown}
                            placeholder={"Select Religion"}
                            selectedvalue={studentDetails.religion}
                        />
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[155px] inline-flex">Caste<span class="req-fld-astrk">*</span></label>
                        <Input
                            type="text"
                            state={studentDetails}
                            id='caste'
                            maxLength={30}
                            inputWidth={`w-[42%] 2xl:w-[50%]`}
                            isMandatoryField={true}
                            placeholder="Enter Caste"
                            handleInput={handleInput}
                            submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                        />
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[155px] inline-flex">Caste Category<span class="req-fld-astrk">*</span></label>
                        <DropDownComponent
                            divClassName={'relative w-[42%] 2xl:w-[50%]'}  
                            showErrorBorder={submitSelected && studentDetails.caste_category === ""}
                            isMandatoryField={true}
                            options={casteCategoryTypes}
                            dropdownkey={"caste_category"}
                            studentDetails={studentDetails}
                            submitSelected={submitSelected}
                            handleDropDownValue={handleDropDownValue}
                            showDropdown={showDropdown}
                            handleDropdown={handleDropdown}
                            placeholder={"Select Category"}
                            selectedvalue={studentDetails.caste_category}
                        />
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[155px] inline-flex adharUploaded">Aadhaar No.</label>
                        <Input
                            type="text"
                            state={parentDetails}
                            id='student_aadhar_number'
                            inputWidth={`w-[42%] 2xl:w-[50%]`}
                            isMandatoryField={true}
                            placeholder="Enter Aadhaar No."
                            handleInput={handleParentInput}
                            maxLength={12}
                            submitSelected={parentDetails.student_aadhar_number !== '' && parentDetails.student_aadhar_number?.length !== 12 && submitSelected}
                            setsubmitSelected={setsubmitSelected}
                            customError={customError}
                        />
                        <div class="ml-1">
                            <div>
                                <FileUploadIcon
                                    state={parentDetails}
                                    fileId="student_aadhar_file"
                                    mainKey="student"
                                    setstate={setParentDetails}
                                    submitSelected={submitSelected}
                                        
                                />
                            </div>
                        </div>
                    </div>
                    <div class="flex items-center w-full">
                        <label class="text-f7 font-normal text-[#031624] min-w-[155px] inline-flex">Register No.</label>
                        <Input
                            type="text"
                            state={studentDetails}
                            id='registration_number'
                            maxLength={30}
                            inputWidth={`w-[42%] 2xl:w-[50%]`}
                            placeholder="Enter Register No."
                            handleInput={handleInput}
                            //submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                        />
                    </div>
                </div>
            </div>
        </div>  )
}

export default BasicDetails
